<template>
  <!-- 移除默认的 onConfirm，改由内部自定义优雅按钮触发 -->
  <Container title="系统参数设置" :returnBtn="false">
    <div class="settings-layout">
      
      <!-- 顶部信息区 -->
      <div class="page-header">
        <div class="header-desc">在这里配置小程序的基础信息、接口安全、第三方密钥以及积分规则。</div>
      </div>

      <!-- 表单内容区 -->
      <div class="form-container">
        <el-form :rules="rules" :model="form" label-position="top" ref="formName" @submit.prevent>
          
          <!-- 卡片 1：基础信息 -->
          <div class="setting-card">
            <div class="card-header">
              <div class="card-title">基础信息</div>
              <div class="card-subtitle">系统运行的基础名称与联系方式</div>
            </div>
            <el-row :gutter="24" class="card-body">
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="系统名称" prop="name">
                  <el-input v-model="form.name" placeholder="例如：中州气联" clearable />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="客户端名称" prop="appname">
                  <el-input v-model="form.appname" placeholder="例如：测试加气站" clearable />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="客服电话" prop="kftel">
                  <el-input v-model="form.kftel" placeholder="请输入客服联系电话" clearable />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="文件服务地址">
                  <el-input v-model="form.fileurl" placeholder="OSS 或 CDN 域名" clearable />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 卡片 2：接口与安全 -->
          <div class="setting-card">
            <div class="card-header">
              <div class="card-title">接口与安全</div>
              <div class="card-subtitle">服务端 API 通信及登录态的有效期控制</div>
            </div>
            <el-row :gutter="24" class="card-body">
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="服务端接口地址">
                  <el-input v-model="form.serverurl" placeholder="http(s)://..." />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="服务端端口">
                  <el-input v-model="form.port" placeholder="例如：8080" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="Token 有效期 (小时)">
                  <el-input type="number" v-model="form.token_time" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="LongToken 有效期 (小时)">
                  <el-input type="number" v-model="form.longtoken_time" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 卡片 3：第三方密钥 -->
          <div class="setting-card">
            <div class="card-header">
              <div class="card-title">第三方密钥</div>
              <div class="card-subtitle">微信小程序及高德地图的相关授权密钥（请注意保密）</div>
            </div>
            <el-row :gutter="24" class="card-body">
              <el-col :xs="24" :sm="12" :md="12" :lg="6" class="form-col">
                <el-form-item label="微信 AppID">
                  <el-input v-model="form.wxappid" show-password />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="6" class="form-col">
                <el-form-item label="微信 Secret">
                  <el-input v-model="form.wxsecret" type="password" show-password />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="6" class="form-col">
                <el-form-item label="高德地图 Key">
                  <el-input v-model="form.amap_key" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="6" class="form-col">
                <el-form-item label="高德安全密钥">
                  <el-input v-model="form.amap_security_code" type="password" show-password />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 卡片 4：积分与推广 -->
          <div class="setting-card">
            <div class="card-header">
              <div class="card-title">积分与推广</div>
              <div class="card-subtitle">用于营销裂变及用户留存的数值配置</div>
            </div>
            <el-row :gutter="24" class="card-body">
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="推广赠送余额 (元)">
                  <el-input type="number" v-model="form.tggivem" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="推广赠送积分">
                  <el-input type="number" v-model="form.tggivep" />
                </el-form-item>
              </el-col>
              <!-- 根据你的注释保留，若需要请删掉注释 -->
              <!-- <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="充值赠送积分数">
                  <el-input type="number" v-model="form.rechargegp" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="充值赠送积分比例(%)">
                  <el-input type="number" v-model="form.rechargepp" />
                </el-form-item>
              </el-col> -->
              <el-col :xs="24" :sm="12" :md="8" :lg="6" class="form-col">
                <el-form-item label="加气赠送积分比例(%)">
                  <el-input type="number" v-model="form.buygivep" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

        </el-form>
      </div>

      <!-- ★ 优雅的吸底操作栏 -->
      <div class="floating-footer">
        <div class="footer-content">
          <!-- 按钮组居中 -->
          <div class="footer-actions">
            <el-button 
              type="primary" 
              class="submit-btn" 
              :loading="saveLoading" 
              @click="onConfirm"
            >
              保存配置
            </el-button>
            <el-button class="cancel-btn" @click="handleCancel">放弃修改</el-button>
          </div>
          <!-- 提示文字放在按钮后面 -->
          <div class="footer-hint">修改配置后请记得点击保存</div>
        </div>
      </div>

    </div>
  </Container>
</template>

<script>
import { pub } from "../../../common/event";
import { ElMessage } from 'element-plus';

export default {
  data: () => {
    return {
      form: {},
      saveLoading: false, // 按钮自带的 Loading 状态
      originalForm: {},   // 用于取消修改时回滚
      rules: {
        name: [{ required: true, message: '系统名称不能为空', trigger: 'blur' }],
        appname: [{ required: true, message: '客户端名称不能为空', trigger: 'blur' }],
        kftel: [{ required: true, message: '客服电话不能为空', trigger: 'blur' }],
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 保存
    onConfirm: async function () {
      this.$refs["formName"].validate(async (valid) => {
        if (valid) {
          this.saveLoading = true;
          try {
            const ret = await this.$api.system.putSystemInfo(this.form);
            if (ret) {
              ElMessage.success('系统参数保存成功');
              this.originalForm = JSON.parse(JSON.stringify(this.form)); // 同步一下备份
              pub("sysinfochange", this.form);
            }
          } catch (e) {
            ElMessage.error("保存失败，请检查网络状态");
          } finally {
            this.saveLoading = false;
          }
        } else {
          ElMessage.warning("请完善必填信息后再提交");
        }
      });
    },
    // 取消 / 放弃修改
    handleCancel: function () {
      // 深度拷贝还原为初始数据
      this.form = JSON.parse(JSON.stringify(this.originalForm));
      this.$refs["formName"].clearValidate();
      ElMessage.info("已恢复至上次保存的配置");
    },
    // 初始化
    init: async function () {
      try {
        const ret = await this.$api.system.getSystemInfo();
        const formdb = {};
        for (let k in ret.data) {
          if (!k.includes('custom')) {
            formdb[k] = ret.data[k];
          }
        }
        this.form = formdb;
        this.originalForm = JSON.parse(JSON.stringify(this.form)); // 保存初始快照
      } catch (e) {
        ElMessage.error("获取系统配置失败");
      }
    },
  },
};
</script>

<style scoped>
/* ================== 整体容器 ================== */
.settings-layout {
  width: 100%;
  min-height: 100%;
  background-color: #f7f9fb;
  padding: 24px 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
}

.page-header {
  width: 100%;
  margin-bottom: 24px;
}
.header-desc {
  font-size: 14px;
  color: #8c98a4;
}

.form-container {
  width: 100%;
  padding-bottom: 80px; /* 给底部悬浮栏留出空间，防止遮挡 */
}

/* 卡片通用样式 */
.setting-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 24px 32px;
  margin-bottom: 20px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.02);
  transition: box-shadow 0.3s;
}
.setting-card:hover {
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
}

.card-header {
  margin-bottom: 20px;
}
.card-title {
  font-size: 17px;
  font-weight: 600;
  color: #1f2d3d;
  margin-bottom: 4px;
}
.card-subtitle {
  font-size: 13px;
  color: #a3aab5;
}

.form-col {
  margin-bottom: 8px;
}

:deep(.el-form-item__label) {
  font-weight: 500;
  color: #4a5568;
  font-size: 13px;
  padding-bottom: 6px !important;
}

/* 输入框美化 */
:deep(.el-input__wrapper) {
  box-shadow: none !important;
  background-color: #f4f6f8;
  border-radius: 8px;
  padding: 4px 12px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}
:deep(.el-input__wrapper:hover) {
  background-color: #edf0f3;
}
:deep(.el-input__wrapper.is-focus) {
  background-color: #ffffff;
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15) !important;
}
:deep(.el-input__inner) {
  height: 34px;
  color: #2c3e50;
  font-weight: 500;
}

/* ================== ★ 吸底操作栏 ================== */
.floating-footer {
  position: sticky;
  bottom: 0;
  z-index: 10;
  margin-top: 10px;
  /* 毛玻璃效果 */
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 12px 12px 0 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.02);
}

.footer-content {
  max-width: 100%;
  padding: 16px 32px;
  display: flex;
  justify-content: center; /* 核心：整体居中 */
  align-items: center;
  gap: 24px; /* 按钮组与提示文字之间的间距 */
}

.footer-actions {
  display: flex;
  gap: 12px;
}

.footer-hint {
  font-size: 13px;
  color: #a3aab5;
}

/* 自定义按钮微动效 */
.cancel-btn {
  border-radius: 8px;
  padding: 10px 24px;
  font-size: 14px;
  border: 1px solid #dcdfe6;
  color: #606266;
  background: transparent;
  transition: all 0.3s;
}
.cancel-btn:hover {
  background: #f5f7fa;
  color: #409eff;
  border-color: #c6e2ff;
}

.submit-btn {
  border-radius: 8px;
  padding: 10px 28px;
  font-size: 14px;
  font-weight: 500;
  background: linear-gradient(135deg, #409eff, #3a8ee6);
  border: none;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.submit-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
  background: linear-gradient(135deg, #55abff, #409eff);
}
.submit-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
}

/* ================== 多端响应式适配 ================== */
@media (min-width: 1600px) {
  .settings-layout {
    padding: 32px 48px;
  }
  .setting-card {
    padding: 32px 40px;
  }
}

@media (max-width: 992px) {
  .settings-layout {
    padding: 20px;
  }
  .setting-card {
    padding: 20px 24px;
  }
  .footer-content {
    padding: 16px 20px;
  }
}

@media (max-width: 768px) {
  .settings-layout {
    padding: 12px;
  }
  .form-container {
    padding-bottom: 100px;
  }
  .setting-card {
    padding: 16px;
    border-radius: 10px;
    margin-bottom: 12px;
  }
  
  /* 手机端：固定吸底，隐藏提示文字，按钮平分全屏 */
  .floating-footer {
    border-radius: 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
  }
  .footer-content {
    padding: 12px 16px;
    justify-content: center;
  }
  .footer-hint {
    display: none;
  }
  .footer-actions {
    width: 100%;
    gap: 12px;
  }
  .cancel-btn, .submit-btn {
    flex: 1; /* 手机端两个按钮平分宽度 */
    height: 44px; /* 增大触摸面积 */
  }
}
</style>